// extracted by mini-css-extract-plugin
module.exports = {"box":"GiftPacking_box_Ey4n9","banner":"GiftPacking_banner_12l-q","content":"GiftPacking_content_6qdtM","btn":"GiftPacking_btn_2IyEl"};